import { IAppState } from '../../redux';

export const selectUserEmail = (state: IAppState): string => {
  return state.user.email;
};
